'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isDOMReady = window && window.document && window.document.createElement;

var ProductFruits = function (_Component) {
  _inherits(ProductFruits, _Component);

  function ProductFruits() {
    _classCallCheck(this, ProductFruits);

    return _possibleConstructorReturn(this, (ProductFruits.__proto__ || Object.getPrototypeOf(ProductFruits)).apply(this, arguments));
  }

  _createClass(ProductFruits, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!isDOMReady) return;

      this.setUserConfig(this.props);
    }
  }, {
    key: 'setUserConfig',
    value: function setUserConfig(reactProps) {
      var projectCode = reactProps.projectCode,
          language = reactProps.language,
          username = reactProps.username,
          email = reactProps.email,
          firstname = reactProps.firstname,
          lastname = reactProps.lastname,
          signUpAt = reactProps.signUpAt,
          role = reactProps.role,
          props = reactProps.props;


      if (!window.productFruits || !window.productFruits.identifyUser) {
        window.productFruitsUser = { username: username, email: email, firstname: firstname, lastname: lastname, signUpAt: signUpAt, role: role, props: props };
      } else {
        window.productFruits.identifyUser({
          username: username,
          email: email,
          firstname: firstname,
          lastname: lastname,
          signUpAt: signUpAt,
          role: role,
          props: props
        });
      }

      window.productFruits = window.productFruits || {};

      var fireLanguageChangedEvent = window.productFruits.language && window.productFruits.language !== language;

      window.productFruits.language = language;
      window.productFruits.code = projectCode;

      if (fireLanguageChangedEvent) {
        document.dispatchEvent(new CustomEvent('pf:language_changed'));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          projectCode = _props.projectCode,
          language = _props.language;


      if (!projectCode || !language || !isDOMReady) {
        console.info('PF - dom is not ready, projectCode is not set or language is not set');
        return;
      }

      if (!window.productFruits) {
        this.setUserConfig(this.props);

        (function (w, d, u, c) {
          var a = d.getElementsByTagName('head')[0];
          var r = d.createElement('script');r.async = 1;
          r.src = u + '?c=' + c;
          _this2.scriptElement = r;
          a.appendChild(r);
        })(window, document, 'https://app.productfruits.com/static/script.js', projectCode);
      }

      if (window.productFruitsUnmounted && window.productFruitsInit) {
        window.productFruitsInit();

        delete window.productFruitsUnmounted;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!isDOMReady || !window.productFruits || !window.productFruits.services) return false;

      window.productFruits.services.destroy();

      delete window.productFruits;
      delete window.productFruitsUser;

      window.productFruitsUnmounted = true;

      this.scriptElement && this.scriptElement.remove();
    }
  }, {
    key: 'render',
    value: function render() {
      return false;
    }
  }]);

  return ProductFruits;
}(_react.Component);

ProductFruits.propTypes = {
  projectCode: _propTypes2.default.string.isRequired,
  language: _propTypes2.default.string.isRequired
};
exports.default = ProductFruits;